import {Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './NavigationIcon.css';

NavigationIcon.propTypes = {
  className: PropTypes.string,
  displayed: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default function NavigationIcon({className, displayed = true, name, onClick, size, style, ...rest}) {
  const defaultIconStyles = {
    zIndex: 1,
    position: 'absolute',
    top: '45%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '0.1em',
    height: '1.5em',
    lineHeight: '1.5em',
    textAlign: 'center',
    paddingBottom: '0.1em',
  };
  const classes = [className || '', displayed ? '' : 'hidden'].join(' ').trim();
  return (
    <Icon name={name}
          size={size}
          className={classes}
          style={{
            ...defaultIconStyles,
            ...style,
          }}
          onClick={onClick}
          link
          {...rest}/>
  );
}
